// src/i18n.js — все переводы проекта

export const TRANSLATIONS = {
  uk: {
    // Navbar
    search_placeholder: 'Я шукаю...',
    search_placeholder_short: 'Я шукаю...',
    logout: 'Вийти',
    // Страница входа
    login_title:    'Вхід до електронного каталогу',
    login_sub:      'Введіть ваші облікові дані',
    login_login:    'Логін читача',
    login_pwd:      'Пароль',
    login_btn:      'Увійти',
    login_entering: 'Вхід...',
    login_guest:    'Увійти як незареєстрований користувач',
    login_register: 'Зареєструватися',
    login_forgot:   'Забули логін або пароль?',
    login_or:       'АБО',
    login_err_conn: "Помилка з'єднання з сервером",
    session_expired_msg: 'Сесія закінчилась, увійдіть знову.',
    records_fund:   'ЗАПИСІВ У ФОНДІ',
    // Реєстрація нового читача
    reg_title:            'Реєстрація нового читача',
    reg_section_personal: 'Особисті дані',
    reg_section_edu:      'Освіта та місце роботи',
    reg_section_contact:  'Контакти',
    reg_section_account:  'Ваші дані для входу',
    reg_lastname:        'Прізвище',
    reg_firstname:       "Ім'я",
    reg_patronymic:      'По батькові',
    reg_birth_year:      'Рік народження',
    reg_education:       'Освіта',
    reg_education_ph:    'Оберіть рівень освіти',
    reg_workplace:       'Місце роботи (навчання)',
    reg_category:        'Категорія',
    reg_category_ph:     'Оберіть категорію',
    reg_phone: 'Телефон мобільний',
    reg_email: 'E-mail',
    reg_login: 'Логін',
    reg_login_checking: 'Перевірка...',
    reg_login_available: 'Логін вільний',
    reg_login_taken_hint: 'Цей логін вже зайнятий',
    reg_password: 'Пароль',
    reg_password_confirm: 'Підтвердіть пароль',
    reg_required_hint: "Поля, позначені *, обов'язкові для заповнення",
    reg_submit_btn:     'Зареєструватися',
    reg_submitting:     'Надсилання...',
    reg_back_to_login:  'Повернутися до входу',
    reg_login_now_btn:  'Увійти',
    reg_success_title:  'Заявку прийнято',
    reg_success_text:   'Дякуємо! Реєстрацію завершено. Тепер ви можете увійти під логіном і паролем, які щойно вказали.',
    reg_autologin_err:  'Не вдалося увійти автоматично. Скористайтеся формою входу.',
    reg_err_required:   "Обов'язкове поле",
    reg_err_email:      'Некоректна e-mail адреса',
    reg_err_phone:      'Некоректний номер телефону',
    reg_err_birth_year: 'Некоректний рік народження',
    reg_err_password_mismatch: 'Паролі не збігаються',
    reg_err_conn:       "Помилка з'єднання з сервером",
    reg_err_login_taken: 'Цей логін вже зайнятий. Будь ласка, оберіть інший і спробуйте ще раз.',
    reg_err_already_registered: 'Схоже, ви вже зареєстровані. Спробуйте увійти або відновити доступ.',
    reg_err_write_failed: 'Не вдалося зберегти заявку. Спробуйте пізніше.',
    reg_err_rate_limited: 'Забагато спроб отримати код. Будь ласка, спробуйте пізніше (приблизно за годину).',
    reg_err_login_format: 'Логін: лише латинські літери, цифри та символи . - _ (від 3 до 30 символів).',
    reg_err_password_short: 'Пароль має містити щонайменше 6 символів.',
    reg_err_too_long:     'Одне з полів занадто довге. Скоротіть, будь ласка.',
    reg_login_hint:       'Латинські літери, цифри та . - _ (3–30 символів)',
    reg_password_hint:    'Щонайменше 6 символів',
    reg_err_sms_failed:   'Не вдалося надіслати SMS. Перевірте номер телефону і спробуйте ще раз.',
    reg_err_phone_ua:     'Самостійна реєстрація можлива лише з українським номером телефону. З іноземним номером зверніться, будь ласка, до бібліотеки.',
    reg_err_sms_quota:    'Сервіс підтвердження тимчасово перевантажений. Будь ласка, спробуйте пізніше або зверніться до бібліотеки.',
    reg_err_paused:       'Реєстрація тимчасово призупинена. Будь ласка, спробуйте пізніше або зверніться до бібліотеки.',
    reg_section_captcha:  'Перевірка, що ви не робот',
    reg_captcha_label:    'Цифри з картинки',
    reg_captcha_alt:      'Картинка з цифрами для перевірки',
    reg_captcha_refresh:  'Інша картинка',
    reg_checking_bot:     'Перевіряємо, що ви не робот...',
    reg_err_captcha_required: 'Введіть 5 цифр з картинки',
    reg_err_captcha_invalid:  'Цифри не збіглися. Введіть, будь ласка, цифри з нової картинки.',
    reg_err_captcha_expired:  'Картинка застаріла. Введіть, будь ласка, цифри з нової картинки.',
    reg_err_captcha_unavailable: 'Не вдалося завантажити перевірку. Натисніть кнопку оновлення поруч із картинкою.',
    reg_err_irbis_unavailable: 'Сервер бібліотеки тимчасово не відповідає. Спробуйте ще раз за хвилину.',
    reg_err_in_progress:  'Опрацьовуємо вашу заявку! Зачекайте кілька секунд і натисніть ще раз.',
    reg_retry_title:      'Майже готово',
    reg_retry_login_taken_text: 'Поки ви підтверджували телефон, цей логін встиг зайняти інший читач. Придумайте інший — повторно вводити код не потрібно.',
    reg_retry_failed_text: 'Не вдалося зберегти дані через тимчасовий збій. Телефон уже підтверджено — просто спробуйте ще раз.',
    reg_retry_login_btn:  'Зберегти з новим логіном',
    reg_retry_btn:        'Спробувати ще раз',
    reg_err_invalid_field: 'Один із довідників (категорія/освіта) не вдалося звірити. Спробуйте оновити сторінку.',
    reg_dict_err: 'Не вдалося завантажити довідники.',
    reg_dict_retry: 'Спробувати ще раз',
    reg_dict_loading: 'Завантаження...',
    // OTP-підтвердження телефону (тимчасовий симулятор, Registration.md розділ 6)
    reg_otp_title:        'Підтвердження номера телефону',
    reg_otp_subtitle:     'Код підтвердження надіслано на номер:',
    reg_otp_debug_label:  'Тестовий режим — SMS/Telegram ще не підключено, код нижче для перевірки:',
    reg_otp_input_label:  'Введіть 6-значний код',
    reg_otp_submit_btn:   'Підтвердити',
    reg_otp_submitting:   'Перевірка...',
    reg_otp_resend_btn:   'Надіслати ще раз',
    reg_otp_resend_limit: 'Ліміт повторних відправок вичерпано',
    reg_otp_reopen_btn:   'Повернутися до підтвердження',
    reg_otp_cancel_btn:   'Скасувати',
    reg_otp_ttl_hint:     'Код дійсний 10 хвилин',
    reg_otp_err_invalid:  'Невірний код. Залишилось спроб:',
    reg_otp_err_expired:  'Код прострочено. Спробуйте зареєструватися ще раз.',
    reg_otp_err_too_many: 'Забагато невірних спроб. Спробуйте зареєструватися ще раз.',
    // Вибір серед тезок (Registration.md розділ 8)
    reg_candidates_title:      'Будь ласка, оберіть свій запис',
    reg_candidates_subtitle:   'У бібліотеці вже є декілька читачів з таким самим ПІБ. Оберіть себе зі списку:',
    reg_candidate_faculty:     'Факультет',
    reg_candidate_program:     'Освітня програма',
    reg_candidate_group:       'Група',
    reg_candidates_pick_btn:   'Це я',
    reg_candidates_none_btn:   'Жоден з цих не я',
    // Екран "можливо, у вас вже є акаунт — це ви?" (редизайн 2026-10-13)
    reg_already_registered_confirm_title: 'Перевірка акаунту',
    reg_already_registered_confirm_text:  'У бібліотеці вже є читач з таким самим ПІБ. Можливо, у вас вже є акаунт?',
    reg_already_registered_yes_btn: 'Так, це я',
    reg_already_registered_no_btn:  'Ні, це не я',
    reg_review_title: 'Потрібна перевірка бібліотекарем',
    reg_review_text:  "На жаль, автоматично визначити ваш запис не вдалося. Заявку передано бібліотекарю на ручну перевірку — з вами зв'яжуться найближчим часом.",
    // Каталог / пошук
    found:          'Знайдено',
    shown:          'показано',
    results_cap_note: 'Для перегляду доступна лише частина знайденого — сервер повертає максимум ~32 тис. записів за один запит. Уточніть запит або додайте фільтри',
    results_relaxed_note: 'Точних збігів немає — показано найближчі за змістом',
    search_suggestion: 'Можливо, ви мали на увазі:',
    results_corrected_for: 'Показано результати для:',
    results_search_instead: 'Шукати натомість:',
    results_more_forms: 'Показати також інші форми слова',
    results_all_forms_note: 'Показано також інші форми слова та споріднені слова',
    sel_select_item: 'Вибрати',
    sel_select_page: 'Вибрати всі на сторінці',
    sel_selected:    'Вибрано',
    sel_clear:       'Очистити',
    sel_cleared:     'Список очищено',
    sel_undo:        'Повернути',
    sel_limit:       'Можна вибрати не більше',
    sel_bar_label:   'Вибрані записи',
    sel_view:        'Переглянути',
    sel_modal_title: 'Вибрані документи',
    sel_close:       'Закрити',
    sel_loading:     'Завантажуємо бібліографічні описи…',
    sel_load_failed: 'Не вдалося завантажити повні описи — показано скорочені',
    sel_shifr:       'Шифр',
    sel_open:        'Відкрити картку видання',
    sel_remove:      'Прибрати зі списку',
    sel_print:       'Друк / PDF',
    sel_print_hint:  'Щоб зберегти у PDF, у вікні друку оберіть «Зберегти як PDF»',
    sel_copy:        'Копіювати',
    sel_copied:      'Список скопійовано',
    sel_copy_failed: 'Не вдалося скопіювати',
    sel_to_bookmarks:'Додати в закладки',
    sel_bm_saved:    'Збережено в закладках',
    sel_bm_failed:   'Не вдалося зберегти закладки',
    sel_print_title: 'Список вибраних документів',
    sel_print_source:'Електронний каталог Наукової бібліотеки УДУ імені Михайла Драгоманова',
    sel_share:          'Поділитися',
    sel_share_hint:     'Посилання на цей список — відкривається в будь-кого, без входу',
    sel_link_copied:    'Посилання скопійовано',
    sel_shared_title:   'Підбірка видань',
    sel_shared_hint:    'Цим списком із вами поділилися. Натисніть на опис видання, щоб переглянути його.',
    sel_shared_failed:  'Не вдалося завантажити підбірку',
    sel_shared_retry:   'Спробувати ще раз',
    sel_shared_empty:   'Записів цієї підбірки більше немає в каталозі',
    sel_shared_missing: 'Недоступні (вилучені з каталогу)',
    sel_shared_add:     'Додати до моїх вибраних',
    sel_shared_added:   'Додано до вибраних',
    sel_shared_already: 'Усі записи вже у ваших вибраних',
    back_selection:     'Повернутися до підбірки',
    search_btn:     'Знайти',
    sort:           'Сортування',
    prev:           'Попередня',
    next:           'Наступна',
    go_btn:         'Перейти',
    page_label:     'Стор.',
    of:             'з',
    loading:        'Завантаження...',
    result_lang_title: 'Мова видання',
    has_external_fulltext: 'Повний текст онлайн',
    result_ca_label: '(зі змісту)',
    // Головна сторінка
    home_main_title:   'Електронний каталог та електронна бібліотека Українського державного університету імені Михайла Драгоманова',
    home_resources_title:    'Наші ресурси',
    home_popular:      'Чим цікавляться?',
    home_top:          'ТОП',
    home_res_library:  'Наукова бібліотека',
    home_res_repo:     'Цифровий репозитарій ENPUIR',
    home_res_digital:  'Цифрові колекції',
    // Back-кнопки
    back_home:         'Повернутися на головну',
    back_results:      'Повернутися до результатів',
    back_cabinet:      'Повернутися до кабінету',
    back_book:         'Повернутися до перегляду видання',
    // Кабінет — вкладки
    cab_issued:        'Книги на руках',
    cab_history:       'Історія видач',
    cab_visits:        'Відвідування',
    cab_fulltexts:     'Повні тексти видання',
    cab_bookmarks:     'Закладки',
    cab_orders:        'Замовлення',
    cab_queries:       'Мої запити',
    // Кабінет — контент
    cab_no_issued:     'Немає книг на руках',
    cab_no_history:    'Історія видач відсутня',
    cab_no_visits:     'Записи про відвідування відсутні',
    cab_no_bookmarks:  'Закладки відсутні',
    cab_no_bookmarks_hint: 'Щоб додати закладку, відкрийте картку книги та натисніть «Додати до закладок»',
    cab_no_queries:    'Збережені запити відсутні',
    cab_no_queries_hint: 'Всі ваші пошукові запити в каталозі зберігаються тут автоматично',
    cab_overdue:       'Заборговано',
    cab_on_hands:      'На руках',
    cab_returned:      'Повернені',
    cab_archive_issued: 'Архів видач',
    cab_archive_visits: 'Архів відвідувань',
    cab_archive_orders: 'Архів замовлень',
    cab_book_open_title:      'Відкрити картку книги',
cab_no_desc:              '(опис відсутній)',
cab_inv_no:               'Інв. №:',
cab_call_number:          'Шифр:',
cab_date_issued:          'Видано:',
cab_date_due:             'Термін:',
cab_date_returned:        'Повернено:',
cab_status_on_hands:      'На руках',
cab_status_overdue:       'Заборговано',
cab_status_returned_f:    'Повернена',
// --- SectionVisits
cab_visits_total:         'Всього відвідувань:',
// --- SectionBookmarks
cab_bookmark_added:       'Додано:',
cab_bookmark_remove:      'Видалити закладку',
cab_bookmarks_clear_all:  'Очистити всі закладки',
// --- SectionQueries
cab_queries_clear_all:    'Очистити все',
cab_q_kw:                 'Ключ.',
cab_q_author:             'Автор',
cab_q_title:              'Назва',
cab_q_discipline:         'Дисципліна',
cab_q_narrow:             'У знайденому',
cab_q_year:               'Рік',
cab_query_repeat_title:   'Повторити запит',
cab_query_repeat:         'Повторити',
cab_query_remove:         'Видалити',
// --- SectionFulltexts
cab_no_fulltexts:         'Звернень до повних текстів ще немає',
cab_fulltexts_clear_all:  'Очистити всі',
cab_ft_open:              'Відкрити знову',
cab_ft_remove:            'Прибрати із записів',
cab_ft_remove_group:      'Видалити всі файли цієї книги',
cab_ft_heading:           'Переглянуті повні тексти',
cab_bm_heading:           'Мої закладки',
cab_qs_heading:           'Збережені запити',
cab_vs_heading:           'Відвідування бібліотеки',
cab_ft_viewed:            'Переглянуто',
// --- Навігація по місяцях
hist_prev_month:          'Попередній місяць',
hist_next_month:          'Наступний місяць',
// --- Секції-заглушки
cab_fulltexts_hint:       'Відкрийте повний текст у картці книги – і він з\'явиться тут',
// --- SectionOrders
cab_orders_active:        'Активні',
cab_orders_inactive:      'Неактивні',
cab_no_orders:            'У вас ще немає замовлень',
cab_no_orders_hint:       'Замовте видання з картки книги – і воно з\'явиться тут',
cab_order_status_pending:   'Не оброблено',
cab_order_status_reserved:  'Заброньовано',
cab_order_status_issued:    'Видано',
cab_order_status_cancelled: 'Скасовано',
cab_order_status_declined:  'Відмовлено',
cab_order_pickup:          'Пункт видачі:',
cab_order_date:            'Дата замовлення:',
cab_order_decline_reason:       'Причина відмови:',
cab_order_decline_reason_01:    'Зайнято',
cab_order_decline_reason_02:    'Немає на місці',
cab_order_decline_reason_03:    'Немає на місці й за топокаталогом',
cab_order_decline_reason_04:    'У палітурці',
cab_order_decline_reason_05:    'Списано',
cab_order_decline_reason_06:    'Лакуна',
cab_order_decline_reason_07:    'Дефектний',
cab_order_decline_reason_08:    'Зношений',
cab_order_decline_reason_09:    'Перенаправлення',
cab_order_decline_reason_other: 'Інше',
// --- Шапка кабінету
cab_guest_name:           'Незареєстрований користувач',
cab_guest_role:           'Гість · доступні Закладки та Мої запити',
cab_refresh:              'Оновити',
cab_loading_data:         'Одну хвилинку! Завантажуємо ваші дані',
cab_alert_overdue_title:  'Увага!',
cab_alert_overdue_text:   'У вас є заборгована література. Будь ласка, поверніть її до бібліотеки.',
cab_guest_notice:         'Ви переглядаєте каталог як гість. Увійдіть до системи, щоб отримати повний доступ до особистого кабінету, замовлення видань та повної історії.',
cab_guest_session_pre:    'Закладки та запити зберігаються лише протягом',
cab_guest_session_bold:   'поточної сесії браузера',
cab_guest_session_post:   '. При закритті вкладки, повторному вході або зміні пристрою — дані скидаються автоматично.',
cab_guest_only:           'Особистий кабінет доступний лише для зареєстрованих читачів.',
cab_conn_error:           "Помилка з'єднання з сервером",

    // Картка книги
    book_loading:      'Завантаження...',
    book_error:        "Помилка з'єднання з сервером",
    book_order:        'Замовити',
    book_format_isbd:    'Перегляд у ISBD',
    book_format_unimarc: 'Перегляд у UNIMARC',

    back:                  'Назад',
    book_on_hand:          'У вас на руках',
    book_all_issued:       'Всі видані',
    book_free_of:          'Вільних',
    book_of:               'з',
    book_copies:           'прим.',
    book_all_issued_badge: 'Усі видані',
    book_login_order:      'Авторизуйтеся для замовлення видання.',
    book_login_fulltext:   'Увійдіть або зареєструйтесь, щоб переглянути повний текст видання.',
    book_go_login:         'Увійти',
    book_go_register:      'Зареєструватися',
    book_share_copy_failed: 'Не вдалося скопіювати посилання автоматично. Скопіюйте адресу з рядка браузера вручну.',
    book_share_email_title: 'Надіслати електронною поштою',
    book_share_email_app: 'Інший Email-застосунок',
    book_order_pickup_title:      'Місце видачі',
    book_order_none_available:    'Немає вільних примірників для замовлення',
    book_order_no_allowed_point:  'У вас немає доступного пункту видачі для цього видання',
    book_order_confirm:           'Підтвердити замовлення',
    book_order_cancel:            'Скасувати',
    book_order_success:           'Замовлення оформлено. Очікуйте на повідомлення від бібліотекаря.',
    book_order_error:             'Не вдалося оформити замовлення. Спробуйте ще раз.',
    book_order_free_label:        'вільних',
    book_order_duplicate:         'Це видання ви вже замовляли. Замовити ще раз?',
    book_order_duplicate_confirm: 'Так, замовити ще раз',
    book_order_restricted:        'Щоб здійснити замовлення, будь ласка, завітайте до бібліотеки для отримання доступу до цієї послуги або напишіть нам.',
    book_order_help_online:       'Допомога онлайн',
    book_order_debt:              'На жаль, ви не можете здійснити замовлення. Будь ласка, поверніть або продовжіть заборговану літературу!',
    book_order_debt_issued_btn:   'Література на руках',
    book_order_ok:                'ОК',
    book_in_bookmarks:     'У закладках',
    book_to_bookmarks:     'До закладок',
    book_main_info:        'Основні відомості',
    book_publisher:        'Видавництво',
    book_year:             'Рік',
    book_edition:          'Видання',
    book_pages:            'Кількість сторінок',
    book_series:           'Серія',
    book_language:         'Мова',
    book_isbn:             'ISBN',
    book_udc:              'УДК',
    book_bbk:              'РУБ',
    book_source:           'Джерело',
    book_issue:            'Номер',
    book_volume:           'Том',
    book_full_desc:        'Бібліографічний запис',
    book_keywords:         'Ключові слова',
    book_annotation:       'Анотація',
    book_availability:     'Примірники',
    book_fulltexts:        'Повні тексти видання',
    book_loans:            'Книговидач:',
    book_web_views:        'Переглядів:',
    book_ft_views:         'Звернень до пов. тексту:',
    book_doi_btn:           'DOI видання',
    ft_ext_label:           'Читати онлайн',
    ft_int_label:           'Повний текст (фонд бібліотеки)',

 // УДК-класифікатор
    udc_sidebar_btn:        'Пошук за класифікатором УДК',
    udc_title:              'Пошук за класифікатором УДК',
    udc_input_placeholder:  'Введіть індекс УДК, наприклад: 37 або 51.01',
    udc_input_placeholder_short: 'Введіть індекс УДК',
    udc_root:               'Усі розділи',
    udc_back:               'Назад',
    udc_records:            'видань',
    udc_count_label:        'вид.',
    udc_search_here:        'Знайти у цьому розділі',
    udc_no_subnodes:        'Підрозділи відсутні',
    udc_empty:              'Одну хвилинку...',
    udc_error:              'Помилка завантаження',
    udc_kw_placeholder:     'Слово або фраза з назви розділу...',
    udc_kw_empty:           'Нічого не знайдено',
    udc_kw_hint:            'напр.: освіта, педагогіка, право, медицина',
    udc_mode_code:          'Індекс УДК',
    udc_mode_kw:            'Ключові слова у рубриках УДК',
    udc_history_label:      'Останні запити',
    udc_history_clear_all:  'Очистити всі',
    udc_history_clear_all_title: 'Очистити всі збережені запити',
    udc_clear_input:        'Очистити',
    udc_selected_search: 'Пошук за відміченими елементами',
    udc_selected_clear:  'Скинути вибір',
    udc_search_title: 'Знайти за УДК:',
    udc_kw_found: 'Знайдено',
    udc_reset_search: 'Скинути пошук',
    udc_logic_or:  'Будь-яке слово',
    udc_logic_and: 'Всі слова',
    udc_options_title: 'Параметри пошуку',
    udc_options_logic: 'Логіка пошуку',
    udc_options_stem:  'Закінчення слів',
    udc_stem_flex:     'не враховувати',
    udc_stem_exact:    'враховувати',

    // Статистика
    stats_title:            'Статистика веб-каталогу',
    stats_visitors:         'Відвідувачі',
    stats_searches:         'Запити за видами пошуку',
    stats_actions:          'За видами дій',
    stats_requests:         'Звернення',
    stats_period_day:       'День',
    stats_period_week:      'Тиждень',
    stats_period_month:     'Місяць',
    stats_period_range:     'Діапазон',
    stats_date_label:       'Дата:',
    stats_refresh:          'Оновити',
    stats_visitors_total:   'Всього',
    stats_visitors_local:   'Мережа (локальна)',
    stats_visitors_internet: 'Мережа Інтернет',
    stats_search_biblio:    'Бібліографічний',
    stats_search_fulltext:  'Повнотекстовий',
    stats_search_both:      'Повнотекстовий і бібліографічний',
    stats_search_udc:       'УДК-Навігатор',
    stats_action_orders:    'Замовлень',
    stats_action_ft_unique: 'Переглянутих повнотекстових ресурсів',
    stats_action_ft_reqs:   'Звернень до повних текстів',
    stats_action_ft_pages:  'Переглянутих сторінок',
    stats_req_total:        'Всього звернень',
    stats_req_views:        'переглядів',
    stats_no_data:          'Немає даних за вибраний період',
    stats_error:            'Помилка завантаження статистики',
    stats_nav:              'Статистика вебкаталогу',
    stats_clear_range: 'Очистити діапазон',
    search_hint_lang: 'Фільтр «Мова» аналізує велику вибірку. Будь ласка, зачекайте...',
    search_hint_long: 'Пошук триває...',
    search_hint_sec:  'с.',
    // --- Сайдбар фільтрів ---
    sidebar_filters_title: 'Розширений пошук',
    sidebar_close:         'Закрити',
    sidebar_filter_applied: 'Фільтр застосовано до результатів',
    sidebar_find:          'Знайти',
    sidebar_finding:       'Пошук...',
    sidebar_reset_all:     'Скинути всі фільтри',
    sidebar_lang_title:    'Мова',
    sidebar_author:        'Автор',
    sidebar_title_lbl:     'Назва',
    sidebar_discipline:    'Дисципліна',
    sidebar_ph_author:     'Наприклад: Шевченко',
    sidebar_ph_title:      'Наприклад: Кобзар',
    sidebar_ph_discipline: 'Наприклад: Математика',
    results_narrow_ph:     'Шукати у знайденому...',
    sidebar_vyd_type:      'Вид/тип видання',
    sidebar_year:          'Рік видання',
    sidebar_year_from:     'з',
    sidebar_year_to:       'по',
    sidebar_fulltext_cb:   'Повний текст (фонд бібліотеки)',

    // --- Вид/тип видання ---
    vyd_all:  '— Усі типи —',
    vyd_kn:   'Книги загалом',
    vyd_05:   'Однотомне видання',
    vyd_03:   'Багатотомне видання',
    vyd_04:   'Видання, що продовжується',
    vyd_01:   'Газета',
    vyd_02:   'Журнал',
    vyd_as:   'Стаття',
    vyd_hd_m2: 'Дисертація',
    vyd_hd_m1: 'Автореферат',
    vyd_ze:   'Картографічні матеріали',
    vyd_zc:   'Ноти (музичні партитури)',
    vyd_zk:   '2-вимірна графіка',
    vyd_zl:   'Електронний ресурс',
    // --- Мови (фільтр) ---
    lang_opt_ukr: 'Українська',
    sidebar_lang_deselect: 'Скинути',
    sidebar_options_btn:   'Розширений пошук',
    // --- Аудит хардкоду: сортування/пагінація ---
    sort_relevance:      'За релевантністю',
    sort_newest_first:   'спочатку нові',
    sort_oldest_first:   'спочатку старі',
    sort_az:             'А–Я',
    sort_za:             'Я–А',
    sort_group_year:     'РІК ВИДАННЯ',
    sort_group_date:     'ДАТА НАДХОДЖЕННЯ',
    sort_group_title:    'НАЗВА',
    sort_group_author:   'АВТОР',
    sort_group_doctype:  'ТИП ДОКУМЕНТУ',
    perpage_suffix:      'на сторінці',
    perpage_all:         'Всі результати',
    // --- Аудит хардкоду: навбар/пошук ---
    logo_alt:              'Логотип',
    nav_home:               'Головна',
    page_title_guest_catalog: 'Каталог (гість)',
    search_query_aria:     'Пошуковий запит',
    search_aria:           'Пошук',
    search_close_aria:     'Закрити пошук',
    search_no_suggestions: 'Немає підказок у цій базі',
    search_recent_queries: 'Останні запити',
    query_remove_title:    'Видалити цей запит',
    query_remove_aria_prefix: 'Видалити запит',
    lang_switch_aria:  'Змінити мову',
    lang_switch_title: 'Змінити мову інтерфейсу',
    theme_light:    'Світла тема',
    theme_dark:     'Темна тема',
    theme_to_light: 'Перейти до світлої теми',
    theme_to_dark:  'Перейти до темної теми',
    scroll_top_aria: 'Прокрутити вгору',
    footer_made_with: 'Створено за допомогою',
    footer_and: 'та',
    footer_author: 'Авторська розробка – Марієнко А.О.',
    // --- Аудит хардкоду: користувач/кабінет-панель ---
    guest_label:           'Гість',
    guest_panel_title:     'Гостьова панель',
    guest_mode_label:      'Гостьовий режим',
    guest_login_prompt:    'Увійдіть до системи, щоб отримати доступ до всіх функцій особистого кабінету.',
    user_menu_aria:        'Меню користувача',
    logout_full:           'Вийти з системи',
    reader_default_category: 'Читач бібліотеки',
    cab_title:             'Кабінет',
    cab_personal_title:    'Особистий кабінет',
    cab_my_title:          'Мій кабінет',
    // --- Аудит хардкоду: back-мітки ---
    back_udc: 'Повернутися до навігатора УДК',
    back_journal: 'Повернутися до зведеного опису журналу',
    // --- Аудит хардкоду: заголовки сторінок/вкладки ---
    book_card_title:       'Картка видання',
    udc_nav_title:         'Навігатор УДК',
    journal_nav_title:     'Зведений опис журналу',
    stats_short_title:     'Статистика',
    // --- Зведений опис журналу (JournalPage.js) ---
    book_journal_summary_link: 'Перейти до зведеного опису журналу',
    journal_years_title:       'Зареєстровані надходження',
    journal_online:             'онлайн',
    journal_issues_empty:      'Немає доступних номерів за цей рік',
    journal_issues_error:      'Не вдалося завантажити номери',
    journal_not_found:         'Журнал не знайдено',
    journal_contents_badge:    'Зміст',
    journal_batches_label:     'Партій',
    journal_select_year_hint:  'Для отримання переліку номерів за певний рік натисніть на картку року.',
    search_results_prefix: 'Результати пошуку',
    login_page_title:      'Вхід',
    udc_back_to_root_title: 'Назад до головних розділів',
    udc_mode_select_aria:   'Режим пошуку УДК',
    udc_kw_see_also_label:  'Дивись також:',
    cab_nav_aria:            'Секції кабінету',
    // --- Аудит хардкоду: сторінка входу (UserLogin.js) ---
    login_err_generic:    'Помилка входу',
    lib_logo_alt:         'Логотип бібліотеки',
    lp_university_name:   'Український державний університет імені Михайла Драгоманова',
    lp_services_label:    'Авторизація відкриває доступ до особистого електронного кабінету, що дозволяє:',
    lp_service_1: 'Зберігати пошукові запити',
    lp_service_2: 'Замовляти видання з фонду',
    lp_service_3: 'Переглядати свій читацький формуляр',
    lp_service_4: 'Користуватись мережевою електронною бібліотекою',
    lp_notice_p1: 'Електронний каталог містить усі видання, що зберігаються у фонді бібліотеки. Серед них є такі, що відображають застарілі наукові підходи або ідеологічні наративи тоталітарних часів, і потребують критичного оцінювання змісту.',
    lp_errors_label: 'Про помилки у роботі системи:',
    lp_copyright: '© Наукова Бібліотека Українського державного університету імені Михайла Драгоманова, 2026',
    login_placeholder: 'Введіть логін',
    pwd_placeholder:   'Введіть пароль',
    lp_info_title:     'Довідкова інформація',
    // --- Аудит хардкоду: результати пошуку ---
    search_timeout_msg:   'Час очікування відповіді від сервера минув.',
    search_timeout_retry_hint: 'Спробуйте ще раз.',
    retry_btn:             'Спробувати ще раз',
    per_page_label:        'По',
    per_page_count_label:  'Кількість на сторінці',
    view_list:              'Список',
    view_grid:               'Сітка',
    found_other_db:         'Знайдено в інших БД:',
    go_to_db_search_prefix: 'Перейти до пошуку в базі',
    view_btn:                'Переглянути',
    view_details_btn:        'Переглянути детально',
    fulltext_available_title: 'Доступний повний текст',
    fulltext_available_badge: 'Є повний текст',
    result_journal_title:    'Періодичне видання (журнал)',
    result_journal_badge:    'Журнал',
    result_hint_prefix:      'Знайдено також у:',
    result_hint_title:       'Слово запиту знайдено в полі, яке не показано на картці',
    result_hint_keywords:    'ключових словах',
    result_hint_subjects:    'предметних рубриках',
    result_hint_contents:    'змісті',
    result_hint_annotation:  'анотації',
    no_author:               'без автора',
    and_others:              'та ін.',
    nothing_found:           'Нічого не знайдено. Спробуйте перефразувати пошуковий запит.',
    popular_empty_hint:      'Статистика накопичується під час роботи з каталогом',
  },
  en: {
    // Navbar
    search_placeholder: 'I’m looking for...',
    search_placeholder_short: 'Search...',
    logout: 'Sign out',
    // Login page
    login_title:    'Library Catalog Login',
    login_sub:      'Enter your credentials',
    login_login:    'Reader login',
    login_pwd:      'Password',
    login_btn:      'Sign in',
    login_entering: 'Signing in...',
    login_guest:    'Continue as guest',
    login_register: 'Register',
    login_forgot:   'Forgot login or password?',
    login_or:       'OR',
    login_err_conn: 'Server connection error',
    session_expired_msg: 'Your session has expired, please log in again.',
    records_fund:   'RECORDS IN COLLECTION',
    // New reader registration
    reg_title:            'New reader registration',
    reg_section_personal: 'Personal details',
    reg_section_edu:      'Education and workplace',
    reg_section_contact:  'Contacts',
    reg_section_account:  'Yours login credentials',
    reg_lastname:        'Last name',
    reg_firstname:       'First name',
    reg_patronymic:      'Patronymic',
    reg_birth_year:      'Birth year',
    reg_education:       'Education',
    reg_education_ph:    'Select education level',
    reg_workplace:       'Workplace (place of study)',
    reg_category:        'Category',
    reg_category_ph:     'Select category',
    reg_phone: 'Mobile phone',
    reg_email: 'E-mail',
    reg_login: 'Login',
    reg_login_checking: 'Checking...',
    reg_login_available: 'Login is available',
    reg_login_taken_hint: 'This login is already taken',
    reg_password: 'Password',
    reg_password_confirm: 'Confirm password',
    reg_required_hint: 'Fields marked with * are required',
    reg_submit_btn:     'Sign Up',
    reg_submitting:     'Submitting...',
    reg_back_to_login:  'Back to login',
    reg_login_now_btn:  'Log in',
    reg_success_title:  'Request accepted',
    reg_success_text:   'Thank you! Registration complete. You can now log in with the login and password you just chose.',
    reg_autologin_err:  'Automatic login failed. Please use the login form.',
    reg_err_required:   'Required field',
    reg_err_email:      'Invalid e-mail address',
    reg_err_phone:      'Invalid phone number',
    reg_err_birth_year: 'Invalid birth year',
    reg_err_password_mismatch: 'Passwords do not match',
    reg_err_conn:       'Server connection error',
    reg_err_login_taken: 'This login is already taken. Choose another one and try again.',
    reg_err_already_registered: 'It looks like you are already registered. Please try to log in or restore access.',
    reg_err_write_failed: 'Could not save your request. Please try again later.',
    reg_err_rate_limited: 'Too many code requests. Please try again later (in about an hour).',
    reg_err_login_format: 'Login: Latin letters, digits and . - _ only (3 to 30 characters).',
    reg_err_password_short: 'Password must be at least 6 characters long.',
    reg_err_too_long:     'One of the fields is too long. Please shorten it.',
    reg_login_hint:       'Latin letters, digits and . - _ (3–30 characters)',
    reg_password_hint:    'At least 6 characters',
    reg_err_sms_failed:   'Could not send the SMS. Please check your phone number and try again.',
    reg_err_phone_ua:     'Self-registration is only available with a Ukrainian phone number. With a foreign number, please contact the library.',
    reg_err_sms_quota:    'The confirmation service is temporarily overloaded. Please try again later or contact the library.',
    reg_err_paused:       'Registration is temporarily suspended. Please try again later or contact the library.',
    reg_section_captcha:  'Check that you are not a robot',
    reg_captcha_label:    'Digits from the picture',
    reg_captcha_alt:      'Picture with digits for verification',
    reg_captcha_refresh:  'Another picture',
    reg_checking_bot:     'Checking that you are not a robot...',
    reg_err_captcha_required: 'Enter the 5 digits from the picture',
    reg_err_captcha_invalid:  'The digits did not match. Please enter the digits from the new picture.',
    reg_err_captcha_expired:  'The picture has expired. Please enter the digits from the new picture.',
    reg_err_captcha_unavailable: 'Could not load the check. Press the refresh button next to the picture.',
    reg_err_irbis_unavailable: 'The library server is temporarily not responding. Please try again in a minute.',
    reg_err_in_progress:  'We are processing your request! Please wait a few seconds and try again.',
    reg_retry_title:      'Almost done',
    reg_retry_login_taken_text: 'While you were confirming your phone, this login was taken by another reader. Please choose a different one — no need to enter the code again.',
    reg_retry_failed_text: 'Your data could not be saved due to a temporary failure. Your phone is already confirmed — just try again.',
    reg_retry_login_btn:  'Save with new login',
    reg_retry_btn:        'Try again',
    reg_err_invalid_field: 'One of the dictionaries (category/education) could not be verified. Please refresh the page.',
    reg_dict_err: 'Could not load dictionaries.',
    reg_dict_retry: 'Try again',
    reg_dict_loading: 'Loading...',
    // Phone OTP confirmation (temporary simulator, Registration.md section 6)
    reg_otp_title:        'Phone number confirmation',
    reg_otp_subtitle:     'A confirmation code has been sent to:',
    reg_otp_debug_label:  'Test mode — SMS/Telegram not connected yet, code shown below for testing:',
    reg_otp_input_label:  'Enter the 6-digit code',
    reg_otp_submit_btn:   'Confirm',
    reg_otp_submitting:   'Checking...',
    reg_otp_resend_btn:   'Resend',
    reg_otp_resend_limit: 'Resend limit reached',
    reg_otp_reopen_btn:   'Back to confirmation',
    reg_otp_cancel_btn:   'Cancel',
    reg_otp_ttl_hint:     'The code is valid for 10 minutes',
    reg_otp_err_invalid:  'Invalid code. Attempts left:',
    reg_otp_err_expired:  'Code expired. Please register again.',
    reg_otp_err_too_many: 'Too many failed attempts. Please register again.',
    // Selecting among namesakes (Registration.md section 8)
    reg_candidates_title:      'Select your record',
    reg_candidates_subtitle:   'The library already has several readers with the same full name. Select yourself from the list:',
    reg_candidate_faculty:     'Faculty',
    reg_candidate_program:     'Study programme',
    reg_candidate_group:       'Group',
    reg_candidates_pick_btn:   "It's me",
    reg_candidates_none_btn:   'None of these is me',
    // "You may already have an account — is this you?" screen (redesign 2026-10-13)
    reg_already_registered_confirm_title: 'Account check',
    reg_already_registered_confirm_text:  'The library already has a reader with the same full name. Do you already have an account?',
    reg_already_registered_yes_btn: "Yes, it's me",
    reg_already_registered_no_btn:  "No, it's not me",
    reg_review_title: 'Librarian review required',
    reg_review_text:  'Unfortunately, we could not automatically match your record. Your request has been sent to the librarian for manual review — you will be contacted soon.',
    // Catalog / search
    found:          'Found',
    shown:          'shown',
    results_cap_note: 'Only part of the result set is browsable — the server returns at most ~32k records per query. Refine your query or add filters',
    results_relaxed_note: 'No exact matches — showing the closest ones',
    search_suggestion: 'Did you mean:',
    results_corrected_for: 'Showing results for:',
    results_search_instead: 'Search instead for:',
    results_more_forms: 'Also show other word forms',
    results_all_forms_note: 'Also showing other word forms and related words',
    sel_select_item: 'Select',
    sel_select_page: 'Select all on this page',
    sel_selected:    'Selected',
    sel_clear:       'Clear',
    sel_cleared:     'List cleared',
    sel_undo:        'Undo',
    sel_limit:       'You can select no more than',
    sel_bar_label:   'Selected records',
    sel_view:        'View',
    sel_modal_title: 'Selected documents',
    sel_close:       'Close',
    sel_loading:     'Loading bibliographic descriptions…',
    sel_load_failed: 'Could not load full descriptions — short ones are shown',
    sel_shifr:       'Call number',
    sel_open:        'Open the item card',
    sel_remove:      'Remove from the list',
    sel_print:       'Print / PDF',
    sel_print_hint:  'To save as PDF, choose “Save as PDF” in the print dialog',
    sel_copy:        'Copy',
    sel_copied:      'List copied',
    sel_copy_failed: 'Could not copy',
    sel_to_bookmarks:'Add to bookmarks',
    sel_bm_saved:    'Saved to bookmarks',
    sel_bm_failed:   'Could not save bookmarks',
    sel_print_title: 'List of selected documents',
    sel_print_source:'Electronic catalog of the Scientific Library of Ukrainian State Dragomanov University',
    sel_share:          'Share',
    sel_share_hint:     'A link to this list — opens for anyone, no sign-in needed',
    sel_link_copied:    'Link copied',
    sel_shared_title:   'Shared list',
    sel_shared_hint:    'This list was shared with you. Click an item description to view it.',
    sel_shared_failed:  'Could not load the list',
    sel_shared_retry:   'Try again',
    sel_shared_empty:   'The items of this list are no longer in the catalog',
    sel_shared_missing: 'Unavailable (removed from the catalog)',
    sel_shared_add:     'Add to my selection',
    sel_shared_added:   'Added to selection',
    sel_shared_already: 'All items are already in your selection',
    back_selection:     'Back to the shared list',
    search_btn:     'Search',
    sort:           'Sort',
    prev:           'Previous',
    next:           'Next',
    go_btn:         'Go',
    page_label:     'Page',
    of:             'of',
    loading:        'Loading...',
    result_lang_title: 'Language of publication',
    has_external_fulltext: 'Full text online',
    result_ca_label: '(from contents)',
    // Home page
    home_main_title:   'Electronic Catalog and Digital Library of Ukrainian State Dragomanov University',
    home_resources_title:    'Our resources',
    home_popular:      'What people read?',
    home_top:          'TOP',
    home_res_library:  'Academic Library',
    home_res_repo:     'ENPUIR Digital Repository',
    home_res_digital:  'Digital collections',
    // Back buttons
    back_home:         'Back to home',
    back_results:      'Back to results',
    back_cabinet:      'Back to cabinet',
    back_book:         'Back to book view',
    // Cabinet — tabs
    cab_issued:        'Books on hand',
    cab_history:       'Loan history',
    cab_visits:        'Visits',
    cab_fulltexts:     'Full texts',
    cab_bookmarks:     'Bookmarks',
    cab_orders:        'Orders',
    cab_queries:       'My queries',
    // Cabinet — content
    cab_no_issued:     'No books on hand',
    cab_no_history:    'No loan history',
    cab_no_visits:     'No visit records',
    cab_no_bookmarks:  'No bookmarks',
    cab_no_bookmarks_hint: 'To add a bookmark, open a book card and click «Add to bookmarks»',
    cab_no_queries:    'No saved queries',
    cab_no_queries_hint:  'All your catalog search queries are saved here automatically',
    cab_overdue:       'Overdue',
    cab_on_hands:      'On hand',
    cab_returned:      'Returned',
    cab_archive_issued: 'Loan Archive',
    cab_archive_visits: 'Visit Archive',
    cab_archive_orders: 'Order Archive',
    // --- BookRow
cab_book_open_title:      'Open book card',
cab_no_desc:              '(no description)',
cab_inv_no:               'Inv. #:',
cab_call_number:          'Call no.:',
cab_date_issued:          'Issued:',
cab_date_due:             'Due:',
cab_date_returned:        'Returned:',
cab_status_on_hands:      'On hand',
cab_status_overdue:       'Overdue',
cab_status_returned_f:    'Returned',
// --- SectionVisits
cab_visits_total:         'Total visits:',
// --- SectionBookmarks
cab_bookmark_added:       'Added:',
cab_bookmark_remove:      'Remove bookmark',
cab_bookmarks_clear_all:  'Clear all bookmarks',
// --- SectionQueries
cab_queries_clear_all:    'Clear all',
cab_q_kw:                 'Keyword',
cab_q_author:             'Author',
cab_q_title:              'Title',
cab_q_discipline:         'Discipline',
cab_q_narrow:             'Within results',
cab_q_year:               'Year',
cab_query_repeat_title:   'Repeat query',
cab_query_repeat:         'Repeat',
cab_query_remove:         'Remove',
// --- SectionFulltexts
cab_no_fulltexts:         'No full text access history yet',
cab_fulltexts_clear_all:  'Clear all',
cab_ft_open:              'Open again',
cab_ft_remove:            'Remove from history',
cab_ft_remove_group:      'Remove all files for this book',
cab_ft_heading:           'Viewed full texts',
cab_bm_heading:           'My bookmarks',
cab_qs_heading:           'Saved searches',
cab_vs_heading:           'Library visits',
cab_ft_viewed:            'Viewed',
// --- Month navigation
hist_prev_month:          'Previous month',
hist_next_month:          'Next month',
// --- Секції-заглушки
cab_fulltexts_hint:       'Open a full text in any book card – it will appear here',
// --- SectionOrders
cab_orders_active:        'Active',
cab_orders_inactive:      'Inactive',
cab_no_orders:            'You have no orders yet',
cab_no_orders_hint:       'Order a book from its card – and it will appear here',
cab_order_status_pending:   'Not processed',
cab_order_status_reserved:  'Reserved',
cab_order_status_issued:    'Issued',
cab_order_status_cancelled: 'Cancelled',
cab_order_status_declined:  'Declined',
cab_order_pickup:          'Pickup location:',
cab_order_date:            'Order date:',
cab_order_decline_reason:       'Decline reason:',
cab_order_decline_reason_01:    'Occupied',
cab_order_decline_reason_02:    'Not on the shelf',
cab_order_decline_reason_03:    'Not on the shelf or in the shelf catalog',
cab_order_decline_reason_04:    'Being rebound',
cab_order_decline_reason_05:    'Written off',
cab_order_decline_reason_06:    'Missing issue',
cab_order_decline_reason_07:    'Defective',
cab_order_decline_reason_08:    'Worn out',
cab_order_decline_reason_09:    'Redirected',
cab_order_decline_reason_other: 'Other',
// --- Шапка кабінету
cab_guest_name:           'Guest user',
cab_guest_role:           'Guest · Bookmarks and My Queries available',
cab_refresh:              'Refresh',
cab_loading_data:         'Just a moment! Loading your data',
cab_alert_overdue_title:  'Attention!',
cab_alert_overdue_text:   'You have overdue items. Please return them to the library.',
cab_guest_notice:         'You are browsing as a guest. Sign in for full access to your personal cabinet, order requests, and complete history.',
cab_guest_session_pre:    'Bookmarks and queries are saved for',
cab_guest_session_bold:   'this browser session only',
cab_guest_session_post:   '. They reset when you close the tab, sign in again, or change device.',
cab_guest_only:           'The personal cabinet is available to registered readers only.',
cab_conn_error:           'Connection error',
    // Book card
    book_loading:      'Loading...',
    book_error:        'Server connection error',
    book_order:        'Order',
    book_format_isbd:    'View in ISBD',
    book_format_unimarc: 'View in UNIMARC',

    back:                  'Back',
    book_on_hand:          'You have this book',
    book_all_issued:       'All copies issued',
    book_free_of:          'Available',
    book_of:               'of',
    book_copies:           'copies',
    book_all_issued_badge: 'All issued',
    book_login_order:      'Please sign in to order this item.',
    book_login_fulltext:   'Sign in or register to view the full text of this item.',
    book_go_login:         'Sign in',
    book_go_register:      'Register',
    book_share_copy_failed: 'Could not copy the link automatically. Please copy it from the browser address bar.',
    book_share_email_title: 'Send by e-mail',
    book_share_email_app: 'Other email app',
    book_order_pickup_title:      'Pickup location',
    book_order_none_available:    'No available copies to order',
    book_order_no_allowed_point:  'You have no available pickup point for this item',
    book_order_confirm:           'Confirm order',
    book_order_cancel:            'Cancel',
    book_order_success:           'Order placed. Wait for a message from the librarian.',
    book_order_error:             'Failed to place the order. Please try again.',
    book_order_free_label:        'available',
    book_order_duplicate:         'You have already ordered this item. Order again?',
    book_order_duplicate_confirm: 'Yes, order again',
    book_order_restricted:        'To place an order, please visit the library in person to get access to this service, or contact us online.',
    book_order_help_online:       'Online help',
    book_order_debt:              'Unfortunately, you cannot place an order. Please return or renew your overdue items.',
    book_order_debt_issued_btn:   'Items on hand',
    book_order_ok:                'OK',
    book_in_bookmarks:     'Bookmarked',
    book_to_bookmarks:     'Bookmark',
    book_main_info:        'Main information',
    book_publisher:        'Publisher',
    book_year:             'Year',
    book_edition:          'Edition',
    book_pages:            'Pages',
    book_series:           'Series',
    book_language:         'Language',
    book_isbn:             'ISBN',
    book_udc:              'UDC',
    book_bbk:              'Rubric',
    book_source:           'Source',
    book_issue:            'Issue',
    book_volume:           'Volume',
    book_full_desc:        'Bibliographic record',
    book_keywords:         'Keywords',
    book_annotation:       'Annotation',
    book_availability:     'Availability',
    book_fulltexts:        'Full texts',
    book_loans:            'Loans:',
    book_web_views:        'Views:',
    book_ft_views:         'Full text accesses:',
    book_doi_btn:          'Publication DOI',
    ft_ext_label:          'Read online',
    ft_int_label:          'Full text (library)',

    // UDC classifier
    udc_sidebar_btn:        'UDC Classification Search',
    udc_title:              'UDC Classification Search',
    udc_input_placeholder:  'Enter UDC index, e.g.: 37 or 51.01',
    udc_input_placeholder_short: 'Enter UDC index',
    udc_root:               'All sections',
    udc_back:               'Back',
    udc_records:            'items',
    udc_count_label:        'items',
    udc_search_here:        'Search in this section',
    udc_no_subnodes:        'No subsections',
    udc_empty:              'Just a moment...',
    udc_error:              'Loading error',
    udc_kw_placeholder:     'Word or phrase from section name...',
    udc_kw_empty:           'Nothing found',
    udc_kw_hint:            'e.g.: education, pedagogy, law, medicine',
    udc_mode_code:          'UDC Index',
    udc_mode_kw:            'Keywords in UDC sections',
    udc_history_label:      'Recent searches',
    udc_history_clear_all:  'Clear all',
    udc_history_clear_all_title: 'Clear all saved searches',
    udc_clear_input:        'Clear',
    udc_selected_search: 'Search in selected sections',
    udc_selected_clear:  'Clear selection',
    udc_search_title: 'Search by UDC:',
    udc_kw_found: 'Found',
    udc_reset_search: 'Reset search',
    udc_logic_or:  'Any word',
    udc_logic_and: 'All words',
    udc_options_title: 'Search options',
    udc_options_logic: 'Search logic',
    udc_options_stem:  'Word endings',
    udc_stem_flex:     'Flexible',
    udc_stem_exact:    'Exact',

    // Statistics
    stats_title:            'Web-catalogue statistics',
    stats_visitors:         'Visitors',
    stats_searches:         'Search Queries by Type',
    stats_actions:          'Actions',
    stats_requests:         'Database Requests',
    stats_period_day:       'Day',
    stats_period_week:      'Week',
    stats_period_month:     'Month',
    stats_period_range:     'Date Range',
    stats_date_label:       'Date:',
    stats_refresh:          'Refresh',
    stats_visitors_total:   'Total',
    stats_visitors_local:   'Local Network',
    stats_visitors_internet: 'Internet',
    stats_search_biblio:    'Bibliographic',
    stats_search_fulltext:  'Full Text',
    stats_search_both:      'Full Text & Bibliographic',
    stats_search_udc:       'UDC Navigator',
    stats_action_orders:    'Orders',
    stats_action_ft_unique: 'Unique Full-Text Resources Viewed',
    stats_action_ft_reqs:   'Full-Text Resource Requests',
    stats_action_ft_pages:  'Pages Viewed',
    stats_req_total:        'Total Requests',
    stats_req_views:        'views',
    stats_no_data:          'No data for selected period',
    stats_error:            'Failed to load statistics',
    stats_nav:              'Catalog Statistics',
    stats_clear_range: 'Clear range',
    search_hint_lang: 'Language filter is scanning a large dataset. Please wait...',
    search_hint_long: 'Searching...',
    search_hint_sec:  'sec.',
    // --- Search filters sidebar ---
    sidebar_filters_title: 'Advanced search',
    sidebar_close:         'Close',
    sidebar_filter_applied: 'Filter applied to results',
    sidebar_find:          'Search',
    sidebar_finding:       'Searching...',
    sidebar_reset_all:     'Reset all filters',
    sidebar_lang_title:    'Language',
    sidebar_author:        'Author',
    sidebar_title_lbl:     'Title',
    sidebar_discipline:    'Discipline',
    sidebar_ph_author:     'E.g.: Shevchenko',
    sidebar_ph_title:      'E.g.: Kobzar',
    sidebar_ph_discipline: 'E.g.: Mathematics',
    results_narrow_ph:     'Search within results...',
    sidebar_vyd_type:      'Publication type',
    sidebar_year:          'Year',
    sidebar_year_from:     'from',
    sidebar_year_to:       'to',
    sidebar_fulltext_cb:   'Full text (library fund)',

    // --- Publication types ---
    vyd_all:  '— All types —',
    vyd_kn:   'Books in general',
    vyd_05:   'Single volume',
    vyd_03:   'Multi-volume edition',
    vyd_04:   'Serial publication',
    vyd_01:   'Newspaper',
    vyd_02:   'Journal',
    vyd_as:   'Article',
    vyd_hd_m2: 'Dissertation',
    vyd_hd_m1: 'Dissertation abstract',
    vyd_ze:   'Cartographic materials',
    vyd_zc:   'Music scores',
    vyd_zk:   '2D graphics',
    vyd_zl:   'Electronic resource',
    // --- Language filter options ---
    lang_opt_ukr: 'Ukrainian',
    sidebar_lang_deselect: 'Deselect',
    sidebar_options_btn:   'Advanced search',
    // --- Hardcoded text audit: sort/pagination ---
    sort_relevance:      'By relevance',
    sort_newest_first:   'newest first',
    sort_oldest_first:   'oldest first',
    sort_az:             'A–Z',
    sort_za:             'Z–A',
    sort_group_year:     'PUBLICATION YEAR',
    sort_group_date:     'DATE ADDED',
    sort_group_title:    'TITLE',
    sort_group_author:   'AUTHOR',
    sort_group_doctype:  'DOCUMENT TYPE',
    perpage_suffix:      'per page',
    perpage_all:         'All results',
    // --- Hardcoded text audit: navbar/search ---
    logo_alt:              'Logo',
    nav_home:               'Home',
    page_title_guest_catalog: 'Catalog (guest)',
    search_query_aria:     'Search query',
    search_aria:           'Search',
    search_close_aria:     'Close search',
    search_no_suggestions: 'No suggestions in this database',
    search_recent_queries: 'Recent queries',
    query_remove_title:    'Delete this query',
    query_remove_aria_prefix: 'Delete query',
    lang_switch_aria:  'Change language',
    lang_switch_title: 'Change interface language',
    theme_light:    'Light theme',
    theme_dark:     'Dark theme',
    theme_to_light: 'Switch to light theme',
    theme_to_dark:  'Switch to dark theme',
    scroll_top_aria: 'Scroll to top',
    footer_made_with: 'Built with',
    footer_and: 'and',
    footer_author: 'Developed by Marienko A.O.',
    // --- Hardcoded text audit: user/cabinet panel ---
    guest_label:           'Guest',
    guest_panel_title:     'Guest panel',
    guest_mode_label:      'Guest mode',
    guest_login_prompt:    'Sign in to access all personal cabinet features.',
    user_menu_aria:        'User menu',
    logout_full:           'Sign out',
    reader_default_category: 'Library reader',
    cab_title:             'Cabinet',
    cab_personal_title:    'Personal cabinet',
    cab_my_title:          'My cabinet',
    // --- Hardcoded text audit: back labels ---
    back_udc: 'Back to UDC navigator',
    back_journal: 'Back to journal summary',
    // --- Hardcoded text audit: page/tab titles ---
    book_card_title:       'Book card',
    udc_nav_title:         'UDC Navigator',
    journal_nav_title:     'Journal summary',
    stats_short_title:     'Statistics',
    // --- Journal summary (JournalPage.js) ---
    book_journal_summary_link: 'Go to journal summary',
    journal_years_title:       'Registered issues',
    journal_online:             'online',
    journal_issues_empty:      'No issues available for this year',
    journal_issues_error:      'Failed to load issues',
    journal_not_found:         'Journal not found',
    journal_contents_badge:    'Contents',
    journal_batches_label:     'Batches',
    journal_select_year_hint:  'Click a year card to see the list of issues for that year.',
    search_results_prefix: 'Search results',
    login_page_title:      'Login',
    udc_back_to_root_title: 'Back to top-level sections',
    udc_mode_select_aria:   'UDC search mode',
    udc_kw_see_also_label:  'See also:',
    cab_nav_aria:            'Cabinet sections',
    // --- Hardcoded text audit: login page (UserLogin.js) ---
    login_err_generic:    'Login error',
    lib_logo_alt:         'Library logo',
    lp_university_name:   'Ukrainian State Dragomanov University',
    lp_services_label:    'Signing in gives access to your personal cabinet, letting you:',
    lp_service_1: 'Save search queries',
    lp_service_2: 'Order items from the collection',
    lp_service_3: 'View your reader record',
    lp_service_4: 'Use the networked digital library',
    lp_notice_p1: 'Dear users! The electronic catalog contains all editions held in the library collection, regardless of the historical context of their creation. Some of them reflect outdated scholarly approaches or ideological narratives of totalitarian eras.',
    lp_errors_label: 'To report system issues:',
    lp_copyright: '© Academic Library of Ukrainian State Dragomanov University, 2026',
    login_placeholder: 'Enter your login',
    pwd_placeholder:   'Enter your password',
    lp_info_title:     'Help information',
    // --- Hardcoded text audit: search results ---
    search_timeout_msg:   'The server response has timed out.',
    search_timeout_retry_hint: 'Please try again.',
    retry_btn:             'Try again',
    per_page_label:        'Show',
    per_page_count_label:  'Results per page',
    view_list:              'List',
    view_grid:               'Grid',
    found_other_db:         'Found in other databases:',
    go_to_db_search_prefix: 'Search in database',
    view_btn:                'View',
    view_details_btn:        'View details',
    fulltext_available_title: 'Full text available',
    fulltext_available_badge: 'Full text available',
    result_journal_title:    'Periodical (journal)',
    result_journal_badge:    'Journal',
    result_hint_prefix:      'Also found in:',
    result_hint_title:       'A query word was found in a field not shown on this card',
    result_hint_keywords:    'keywords',
    result_hint_subjects:    'subject headings',
    result_hint_contents:    'contents',
    result_hint_annotation:  'annotation',
    no_author:               'no author',
    and_others:              'and others',
    nothing_found:           'Nothing found. Try rephrasing your search query.',
    popular_empty_hint:      'Statistics accumulate as the catalog is used',
  },
};

export function t(lang, key) {
  return (TRANSLATIONS[lang] || TRANSLATIONS['uk'])[key] || key;
}